import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';
import SICoachChat from '../components/SICoachChat';

const GRAD = 'linear-gradient(135deg, #d97706, #b45309)';

const SUGGESTIONS = [
  { icon: '🗣️', label: 'Breaking Bad News', q: 'Teach me the SPIKES protocol with an example script for an abnormal biopsy result' },
  { icon: '💬', label: 'Patient Counselling', q: 'How do I counsel an anxious patient who refuses a needed surgery?' },
  { icon: '🎤', label: 'Public Speaking', q: 'Help me prepare a confident 10-minute conference presentation' },
  { icon: '👥', label: 'Leadership', q: 'How do I handle a staff member who keeps making errors, without demotivating the team?' },
  { icon: '⏰', label: 'Time Management', q: 'My OPD always runs late — give me a system to manage time better' },
  { icon: '🌱', label: 'Learn a New Skill', q: 'I want to learn medical writing — give me a 30-day learning plan' },
  { icon: '🤝', label: 'Negotiation', q: 'How do I negotiate better terms with a hospital I consult at?' },
  { icon: '⭐', label: 'Personal Branding', q: 'How do I build my reputation as a trusted doctor in my city?' },
];

const MD_COMPONENTS = {
  h2: (props) => <h2 className="text-lg font-bold text-amber-200 mt-4 mb-2" {...props} />,
  h3: (props) => <h3 className="text-base font-bold text-amber-200 mt-3 mb-1.5" {...props} />,
  p: (props) => <p className="text-white/85 mb-3" {...props} />,
  strong: (props) => <strong className="text-white font-bold" {...props} />,
  ul: (props) => <ul className="list-disc pl-5 mb-3 space-y-1.5 text-white/85 marker:text-amber-300" {...props} />,
  ol: (props) => <ol className="list-decimal pl-5 mb-3 space-y-1.5 text-white/85 marker:text-amber-300" {...props} />,
};

export default function GynovatePersonalPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen text-white" style={{ background: 'radial-gradient(1200px 600px at 80% -10%, rgba(217,119,6,0.18), transparent), #141210' }}>
      <header className="sticky top-0 z-20 backdrop-blur-xl border-b border-white/10" style={{ background: 'rgba(20,18,16,0.8)' }}>
        <div className="max-w-3xl mx-auto px-5 py-3 flex items-center justify-between">
          <button onClick={() => navigate('/chat')} data-testid="personal-back-btn" className="flex items-center gap-1.5 text-sm text-white/70 hover:text-white whitespace-nowrap">
            <ArrowLeft className="w-4 h-4" /> Copilot
          </button>
          <div className="flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg flex items-center justify-center text-sm" style={{ background: GRAD }}>🌟</span>
            <span className="text-xs font-black tracking-[0.2em] uppercase">Gynovate Personal</span>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 pb-16 pt-10">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-amber-300/70 mb-3 flex items-center gap-2"><Sparkles className="w-3.5 h-3.5" /> Personal Development · For Doctors</p>
        <h1 className="text-4xl sm:text-5xl font-black leading-[1.05] tracking-tight mb-3">
          Grow beyond<br />
          <span style={{ background: GRAD, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>the white coat.</span>
        </h1>
        <p className="text-white/60 text-sm sm:text-base mb-8 max-w-xl">Communication, counselling skills, leadership, public speaking, time management — and any new skill you want to master. Your personal coach, built for doctors.</p>

        <SICoachChat
          coach="personal"
          source="Gynovate Personal"
          accentGrad={GRAD}
          accentText="text-amber-300/70"
          chipClass="border-white/10 bg-white/[0.04] hover:border-amber-300/50 hover:bg-amber-400/10"
          suggestions={SUGGESTIONS}
          placeholder="Ask about any skill — communication, leadership, speaking…"
          mdComponents={MD_COMPONENTS}
        />
      </main>
    </div>
  );
}
